<script lang="ts">
  import Select from './ui/select/select.svelte';
  import { cn } from '$lib/utils';
  import { objectKeys } from '$lib/utils/object';
  import { buildPath } from '$lib/utils/paths';
  import { defaultLang, isLang, lang, languages } from '$lib/lang';
  import type { Selected } from 'bits-ui';
  import { currentLocation } from '$lib/region';

  let className: string | undefined = undefined;
  export { className as class };
  export let variant: 'short' | 'long' = 'long';

  const onChange = (e: CustomEvent<Selected<string> | undefined>) => {
    if (e.detail) {
      const currentLang = isLang(e.detail.value) ? e.detail.value : defaultLang;
      window.location.replace(
        $buildPath({
          lang: currentLang,
          region: $currentLocation
        })
      );
    }
  };

  let value: string = $lang;
  $: items = objectKeys(languages).map((lang) => ({
    value: lang,
    label: variant === 'short' ? lang : languages[lang] || lang
  }));
</script>

<Select
  variant="link"
  icon="language"
  bind:value
  {items}
  on:change={onChange}
  class={cn(className, 'text-sm')}
  sameWidth={false}
  popoverClass="min-w-32"
  size="sm"
/>
